import React from 'react'
import './Section6.css'

const Section6 = () => {
  return (
    <div className="Newletter-container" >
        <div className="Newletter-div">
          <h3>JOIN OUR NEWSLETTER</h3>
          <div className="Newletter-links-container">
            <a href="">INSTAGRAM</a>
            <a href="">FACEBOOK</a>
            <a href="">TWITTER</a>
            <a href="">PINTEREST</a>
            <a href="">YOUTUBE</a>
            <a href="">SPOTIFY</a>
          </div>
        </div>
    </div>
  )
}

export default Section6